import React, { useState, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const TransferMoneyButton = ({ contract, onTransferClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef(null);

  const handleOpen = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (option) => {
    handleClose();
    onTransferClick(contract, option);
  };

  return (
    <>
      <Tooltip title="Transfer Money">
        <button
          ref={buttonRef}
          className="d-block base-button icon-button icon-button-small evo-blue ml-2"
          onClick={handleOpen}
          type="button"
        >
          <span className="material-icons">currency_exchange</span>
        </button>
      </Tooltip>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleSelect("ledger")}>
          To/From Funds Ledger
        </MenuItem>
        <MenuItem onClick={() => handleSelect("trip")}>
          To another Trip/Contract
        </MenuItem>
      </Menu>
    </>
  );
};

export default TransferMoneyButton;
